import { Radio } from "antd"
import { type RadioGroupProps } from "antd/es/radio"
import { type CSSProperties } from "react"

import Flex from "./Flex"

const RadioGroup = (
  props: RadioGroupProps & {
    center?: boolean
    style?: CSSProperties
    // Radio.Group forwards data-* onto its wrapper div, which is the only way
    // to scope a locator to one filter bar on a page that renders several.
    "data-testid"?: string
  }
) => {
  const { center, ...rest } = props
  return (
    <Flex center={center}>
      <Radio.Group
        // Left these as an example
        // defaultValue="Apple"
        // options={[{ label: "Apple", value: "Apple" }]}

        optionType="button"
        buttonStyle="solid"
        style={{
          ...props.style,
          display: "flex",
          gap: 10,
        }}
        {...rest}
      />
    </Flex>
  )
}

export default RadioGroup
